class SiblingSwatch extends HTMLElement {
  constructor() {
    super();
    this.url = this.getAttribute("data-url");
    this.currentUrl = this.getAttribute("data-current-url");
    this.location = this.getAttribute("data-location");
  }

  async connectedCallback() {
    if (!this.url) return;

    try {
      const response = await fetch(this.url);
      if (!response.ok) throw new Error("Network response was not ok");

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const sectionContent = doc.getElementById("shopify-section-sibling-swatch");

      if (!sectionContent || !sectionContent.innerHTML.trim()) {
        this.remove();
        return;
      }

      // Highlight active swatch
      if (this.url.includes(this.currentUrl) && this.location === "pdp") {
        const link = sectionContent.querySelector("a");
        if (link) {
          link.style.boxShadow = "0 0 2px rgba(0,0,0,0.6)";
          link.style.border = "1px solid";
        }
      }

      this.innerHTML = sectionContent.innerHTML;


      if (this.location == "product-card" && this.querySelector('a')) {
        this.image = this.querySelector('a').getAttribute("data-image");
        this.querySelector('a')?.addEventListener("click", (e) => {
          e.preventDefault();
          const main_image = this.closest("product-card").querySelector(".product-card__media img");
          main_image.setAttribute("src", this.image);
          main_image.removeAttribute("srcset");
          main_image.removeAttribute("sizes");
        })
      }

    } catch (error) {
      console.error("SiblingSwatch fetch error:", error);
      this.remove();
    }

    this.dispatchEvent(new CustomEvent("sibling-swatch:updated", { bubbles: true }));
  }
}

if (!customElements.get('sibling-swatch')) {
  customElements.define('sibling-swatch', SiblingSwatch);
}

class SiblingItems extends HTMLElement {
  constructor() {
    super();
    this.location = this.getAttribute("data-location");
    this.url = this.getAttribute("data-current-url");
    this.debounceTimer = null;

    this.handleSwatches = this.handleSwatches.bind(this);
  }

  connectedCallback() {
    this.addEventListener("sibling-swatch:updated", this.handleSwatches);
  }

  disconnectedCallback() {
    this.removeEventListener("sibling-swatch:updated", this.handleSwatches);
    clearTimeout(this.debounceTimer);
  }

  handleSwatches() {
    // Debounce with 100ms delay
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => this.updateSwatches(), 100);
  }

  updateSwatches() {
    const swatches = Array.from(this.querySelectorAll("sibling-swatch"));
    const swatchCount = swatches.length;

    // Cleanup existing show-more button
    this.querySelector(".show-more-sibling-swatches")?.remove();

    // Reset visibility
    swatches.forEach(el => el.style.display = "");

    if (swatchCount <= 3) return;

    // Hide extra swatches
    swatches.slice(3).forEach(el => el.style.display = "none");

    // Create Show More button
    const showMoreBtn = document.createElement("button");
    showMoreBtn.className = "show-more-sibling-swatches";
    showMoreBtn.setAttribute("aria-label", "Show more swatches");

    switch (this.location) {
      case "pdp":
        showMoreBtn.textContent = `+${swatchCount - 3}`;
        showMoreBtn.style.cssText = "cursor:pointer;height:40px;width:80px;border:1px solid;";
        showMoreBtn.addEventListener("click", () => {
          swatches.slice(3).forEach(el => el.style.display = "");
          showMoreBtn.remove();
        });
        this.appendChild(showMoreBtn);
        break;

      case "product-card":
        showMoreBtn.textContent = `+${Shopify.locale === 'de' ? "Mehr" : "More"}`;
        showMoreBtn.style.cssText = "cursor:pointer;text-decoration:underline;background:none;border:none;color:inherit;";
        showMoreBtn.addEventListener("click", () => {
          window.location.href = this.url;
        });
        this.appendChild(showMoreBtn);
        break;

      default:
        console.warn(`Unknown location "${this.location}" in SiblingItems`);
    }
  }
}

if (!customElements.get('sibling-items')) {
  customElements.define('sibling-items', SiblingItems);
}
